module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_innlandet_neg.10e2cdaa.pdf";